<template>
    <div class="card-content">
        <div class="content">
            <div class="is-size-3 is-subtle has-text-weight-bold">
                {{ $t("comp.nextup.header") }}
            </div>
        </div>
        <div class="wrapper-box">
            <div v-if="!error" class="result-box">
                <!-- <div class="result" v-if="full">
                <div class="result_label">Nome</div>
                <div
                    :class="
                        new Date(tesserato?.expires) < new Date()
                            ? 'error_field'
                            : 'result_field'
                    "
                >
                    {{ tesserato?.firstName?.toLowerCase() }}
                </div>
            </div>
            <div class="result" v-if="full">
                <div class="result_label">Cognome</div>
                <div
                    :class="
                        new Date(tesserato?.expires) < new Date()
                            ? 'error_field'
                            : 'result_field'
                    "
                >
                    {{ tesserato?.lastName?.toLowerCase() }}
                </div>
            </div> -->

                <b-carousel-list
                    :v-model="slide"
                    :arrow="false"
                    arrow-hover
                    :items-to-list="15"
                    repeat
                    has-drag
                    class="full-carousel"
                    :pause-hover="false"
                    animated="fade"
                    autoplay
                    :indicator="false"
                    :interval="2000"
                    :items-to-show="events.length > 1 ? 2 : 1"
                    :data="events"
                >
                    <!-- has-grayscale -->
                    <!-- has-opacity -->
                    <template #item="event">
                        <div class="rel">
                            <!-- <div
                            class="bg-overlay"
                            :style="{ backgroundColor: event.backgroundColor }"
                        /> -->
                            <figure lazy class="bg-image" v-if="event.image">
                                <nuxt-img
                                    loading="lazy"
                                    alt="carousel-image"
                                    :src="event?.image"
                                />
                            </figure>
                            <div class="text-overlay">
                                <div>
                                    <div
                                        class="is-size-3 has-text-weight-bold is-uppercase"
                                    >
                                        {{ event.title }}
                                    </div>
                                    <div
                                        class="is-size-5 has-text-weight-bold is-uppercase"
                                    >
                                        {{
                                            $dateFns.format(
                                                event.start,
                                                "dddd DD MMMM",
                                                {
                                                    locale: $t("event.locale"),
                                                }
                                            )
                                        }}
                                        {{
                                            $dateFns.format(
                                                event.start,
                                                "HH:mm",
                                                {
                                                    locale: $t("event.locale"),
                                                }
                                            )
                                        }}
                                    </div>

                                    <div class="is-size-6">
                                        {{ event.summary.slice(0, 100) }}...
                                    </div>
                                </div>
                                <b-button
                                    class="discover-btn is-uppercase has-text-weight-bold"
                                    :to="localePath(`/event/${event?.id}`)"
                                    tag="router-link"
                                    size="is-medium"
                                    icon-right="fas fa-arrow-right"
                                >
                                </b-button>
                            </div>

                            <!-- <b-image :lazy="false" class="bg-image" :src="getImgUrl(i)"></b-image> -->
                        </div>
                    </template>
                </b-carousel-list>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.discover-btn {
    align-self: flex-end;
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1rem;
    background: var(--color-primary-alt);
    color: white !important;
}
.card-content {
    padding: 0;
}
.content {
    margin: 1.5rem 1.5rem 1rem 1.5rem;
    padding: 0;
}
.rel {
    background: var(--bg-secondary);

    position: relative;
    height: 100%;
    width: 100%;
}

.full-carousel {
    overflow: hidden;
    // border-radius: 1rem;
    max-height: 450px;
    margin: 0;
    width: 100%;
    height: 100%;
}
.bg-image {
    border-radius: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    // max-height: 450px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    // border: 1px solid red;
    img {
        filter: blur(5px) brightness(0.7);
        transform: scale(1.1);
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }
}

.text-overlay {
    // pointer-events: none;
    position: relative;
    padding: 1rem;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: white;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    // background: rgba(var(--bg-rgba), 0.45);
    z-index: 100;
}
.card-collapse {
    .card-collapse-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 1rem;
        margin-bottom: 0;
    }
    width: 100%;
    background: var(--bg);
}
.wrapper-box {
    // border: 1px solid var(--color-danger);
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.submit-btn {
    background: rgba(var(--bg-rgba), 0.3) !important;
    width: 100%;
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 0 1.5rem;
    margin: 1rem 0 0 0 !important;
    align-items: center;
    .icon {
        font-size: 2rem !important;
    }
}
.error_field {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-danger);
    /* margin-bottom: 0.35rem; */
}
.info-box {
    padding: 1.5rem 1rem 0 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.result-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    background: var(--bg);
    // border-radius: 1rem;
    &.is-errored {
        background: rgba(var(--color-danger-rgba), 0.35) 0%;
    }
}
.result_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    text-transform: capitalize;
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}

.query_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    color: var(--color-primary-alt);
    // color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.success_field {
    font-size: 1.25rem;
    font-weight: 500 !important;
    // color: var(--color-primary);
    color: var(--color-success);
    /* margin-bottom: 0.35rem; */
}
.result > .result_field {
    text-align: center;
    font-weight: 300;
}
.result {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
}
</style>
<script>
export default {
    data() {
        return {
            size: 0,
            open: false,
            slide: 0,
        };
    },

    props: {
        events: {
            type: Array,
            default: () => [],
        },
        error: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.onResize();
        });
        const maxIndex = this.events.length - 1;
        console.log(`maxIndex: ${maxIndex}`);
        // switch index every 5 seconds
        setInterval(() => {
            this.index = this.index < maxIndex ? this.index + 1 : 0;
            this.index = console.log(`index: ${this.index}`);
        }, 5000);

        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        getScreenSize() {
            const width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;

            return width;
        },
        onResize() {
            this.size = this.getScreenSize();
        },
    },
};
</script>
